import { Box, Chip } from "@mui/material"
import type { FC } from "react"

interface ManufacturerCellProps {
  manufacturer?: string | null
}

export const ManufacturerCell: FC<ManufacturerCellProps> = ({ manufacturer }) => {
  return (
    <Box className='flex items-center'>
      {manufacturer && (
        <Chip label={manufacturer} size='small' className='rounded bg-primary-200 text-xs text-gray-900' />
      )}
    </Box>
  )
}
